import InputField from "../Utils/InputField";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  InputGroup,
} from "reactstrap";
import {
  handleClearSearch,
  handleInputChange,
  handleSearch,
} from "./constants/ListingCustomerFunctions";
import { useSelector } from "react-redux";
import { useState } from "react";

export const TelcoHeaderForCustomer = ({
  dispatch,
  setLoading,
  setGetTable,
  customerPermission,
  setErrors,
  setErrorMessage,
  setErrorIcon,
  integerAndTextAttributes,
  searchFields,
  setSearchFields,
  setRenderSimulate,
  stationPermission,
  reservationPermission,
  setSearchExpanding,
}) => {
  const [option, setOption] = useState();
  const [value, setValue] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );
  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;
  const placeholderText = isEIPEnabled ? "Device ID" : "Account Number";

  const attributeOptions = integerAndTextAttributes?.map((attribute) => ({
    label: attribute.name,
    value: attribute.name,
  }));
  const options = attributeOptions && [
    ...attributeOptions,
    { label: placeholderText, value: "accountNumber" },
    { label: "Subscription ID", value: "subscriptionid" },
  ];
  return (
    <>
      <div className="d-flex flex-column flex-lg-row align-items-center justify-content-start gap-2">
        <InputGroup className="customer-search-width">
          {/* 🔽 Dropdown */}
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
            // style={{ minWidth: "180px" }}
          >
            <DropdownToggle
              // caret
              className={`search-dropdown d-flex align-items-center px-3 py-1 rv-border-right-none ${
                !option ? "text-black-50" : ""
              }`}
            >
              {option?.label || "Select"}
              <i className="ri-arrow-down-s-line ms-5"></i>
            </DropdownToggle>
            <DropdownMenu>
              {options?.map((opt) => (
                <DropdownItem
                  key={opt.value}
                  onClick={() => setOption(opt)}
                  className="text-dark"
                >
                  {opt.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>

          {/* 🧾 Input Field */}
          <InputField
            className="form-control w-md-auto px-3 py-1 rv-box-shodow-none"
            placeholder={
              option?.label ? `Enter ${option.label}` : "Enter value"
            }
            value={value}
            handleChange={(e) =>
              handleInputChange(option, e.target.value, setErrors, setValue)
            }
            maxLength={
              option?.label === "accountNumber" ? "32" : value?.maxValue
            }
            minLength={
              option?.label === "accountNumber" ? "4" : value?.minValue
            }
            onKeyDown={(e) => {
              if (e.key === "Enter" && option && value) {
                handleSearch(
                  dispatch,
                  setLoading,
                  value,
                  option,
                  setGetTable,
                  setErrors,
                  setErrorMessage,
                  setErrorIcon,
                  searchFields,
                  setRenderSimulate,
                  reservationPermission,
                  stationPermission,
                  customerPermission,
                  setSearchExpanding
                );
              }
            }}
          />
        </InputGroup>

        {/* 🔍 Search Button */}
        <div className="d-flex flex-row gap-2">
          <Button
            onClick={() =>
              handleSearch(
                dispatch,
                setLoading,
                value,
                option,
                setGetTable,
                setErrors,
                setErrorMessage,
                setErrorIcon,
                searchFields,
                setRenderSimulate,
                reservationPermission,
                stationPermission,
                customerPermission,
                setSearchExpanding
              )
            }
            disabled={!option || !value}
            className="btn-label rv-primary-btn rounded-1 px-2 py-1"
          >
            <i className="ri-search-line label-icon align-middle fs-16 me-2 me-3"></i>
            <span className="ps-4 ms-3 me-1">Search</span>
          </Button>
          <Button
            outline
            color="secondary"
            disabled={!option || !value}
            className={"btn-label rv-secondary-btn rounded-1 px-2 py-1 "}
            onClick={() =>
              handleClearSearch(
                setGetTable,
                setErrors,
                setErrorMessage,
                setErrorIcon,
                searchFields,
                setSearchExpanding,
                setSearchFields,
                setValue,
                setOption
              )
            }
          >
            <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2 px-0 mx-0"></i>
            <span className="ps-4 ms-3 me-1">Clear</span>
          </Button>
        </div>
      </div>
    </>
  );
};
